import React from 'react';

import {
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch, StatusFilterSelect } from 'common/components';

import { getCompaniesOptions } from '../helpers';

import CustomDatePicker from './CustomDatePicker';

const BulkOperationsCard = ({
    companies,
    filterData,
    handleOnChangeFilter,
}) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="end" justifyContent="flex-end">
                    <Grid size={18}>
                        <InputSearch
                            onChange={(e) =>
                                handleOnChangeFilter(
                                    e.target.value,
                                    'searchText',
                                )
                            }
                            placeholder={t('Search')}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid size="grow">
                        <CustomDatePicker
                            inputFormat="dd/MM/yyyy"
                            label={t('Initial date')}
                            maxDate={new Date()}
                            name="initial_date"
                            onChange={(value) =>
                                handleOnChangeFilter(value, 'initial_date')
                            }
                            value={filterData?.initial_date}
                            variant="standard"
                        />
                    </Grid>

                    <Grid size="grow">
                        <CustomDatePicker
                            inputFormat="dd/MM/yyyy"
                            label={t('Final date')}
                            maxDate={new Date()}
                            name="final_date"
                            onChange={(value) =>
                                handleOnChangeFilter(value, 'final_date')
                            }
                            value={filterData?.final_date}
                            variant="standard"
                        />
                    </Grid>

                    <Grid size="grow">
                        <FormControl fullWidth size="small">
                            <InputLabel>{t('Filter by company')}</InputLabel>
                            <Select
                                label={t('Filter by company')}
                                onChange={(e) =>
                                    handleOnChangeFilter(
                                        e.target.value,
                                        'companyId',
                                    )
                                }
                                value={filterData?.companyId}
                                variant="standard"
                            >
                                {getCompaniesOptions(companies).map(
                                    ({ label, value, disabled }) => (
                                        <MenuItem
                                            disabled={disabled}
                                            key={`company-select-${value}-${label}`}
                                            value={value}
                                        >
                                            {label}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size="grow">
                        <FormControl fullWidth size="small">
                            <InputLabel>{t('Filter by status')}</InputLabel>
                            <Select
                                label={t('Filter by status')}
                                onChange={(e) =>
                                    handleOnChangeFilter(
                                        e.target.value,
                                        'date_render_filter',
                                    )
                                }
                                value={filterData?.date_render_filter}
                                variant="standard"
                            >
                                {[
                                    {
                                        label: t('All text_plural'),
                                        value: 'all',
                                    },
                                    { label: t('Draft'), value: 'draft' },
                                    {
                                        label: t('Generated'),
                                        value: 'generated',
                                    },
                                ].map(({ label, value, disabled }) => (
                                    <MenuItem
                                        disabled={disabled}
                                        key={`company-select-${value}-${label}`}
                                        value={value}
                                    >
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size="grow">
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={(value) =>
                                handleOnChangeFilter(value, 'status')
                            }
                            variant="standard"
                        />
                    </Grid>
                </Grid>
            </Card.Body>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    companies: PropTypes.array,
    filterData: PropTypes.object,
    handleOnChangeFilter: PropTypes.func,
};

export default BulkOperationsCard;
